import { reportToSentry } from '../../library/sentry'
import { DEFAULT_LOG_LEVEL } from '../../../shared/constants'

const LOG_LEVEL = process.env.LOG_LEVEL || DEFAULT_LOG_LEVEL
const logLevels = ['error', 'warn', 'info', 'debug']
const logDebug = logLevels.indexOf(LOG_LEVEL) > 2
const logInfo = logLevels.indexOf(LOG_LEVEL) > 1
const logWarn = logLevels.indexOf(LOG_LEVEL) > 0

export const logger = {
  info: (...args) => logInfo && console.info(...args),
  debug: (...args) => logDebug && console.debug(...args),
  warn: (...args) => logWarn && console.warn(...args),
  error: (error, ...args) => {
    reportToSentry(error, { extras: { 'logger.error args': args } })

    // Feather error have some weird formatting going on so we log it manually.
    if (error.type === 'FeathersError') {
      console.error(error.toString(), error.toJSON())
    } else {
      console.error(error, ...args)
    }
  }
}
